import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AppPropertyBasicModel,
  BankAccountInfoModel,
  BankAccountRequest,
  Currency,
  Folder,
  HxAuthService,
  HxFileService,
  HxOrganizationService,
  HxStoreService,
  HxUiLabelPipe,
  HxUserService,
  OrganizationModel,
  OrganizationProperty,
  PaymentType,
  StoreBasicModel,
  SysFilename,
  TableRef,
  UiError,
  UiLabel,
  UserBasicModel
} from 'hx-services';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { from, Observable, Subject, zip } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzUploadChangeParam, NzUploadComponent, NzUploadFile } from 'ng-zorro-antd/upload';
import { finalize, map } from 'rxjs/operators';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import {
  HxBankSelectComponent,
  HxCountrySelectComponent,
  HxEnumSelectComponent,
  HxLabelEditComponent,
  HxOrgSelectComponent,
  HxStoreSelectComponent,
  HxUserSelectComponent
} from 'hx-components';
import { NzRadioComponent, NzRadioGroupComponent } from 'ng-zorro-antd/radio';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NgFor, NgIf } from '@angular/common';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzTagComponent } from 'ng-zorro-antd/tag';
import { NzModalComponent, NzModalContentDirective } from 'ng-zorro-antd/modal';

@Component({
    selector: 'hc-organization-edit',
    templateUrl: './organization-edit.component.html',
    styleUrls: ['./organization-edit.component.less'],
  imports: [NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, TranslocoDirective, NzSkeletonComponent, FormsModule, NzFormDirective, ReactiveFormsModule, NzRowDirective, NzColDirective, NzFormItemComponent, NzFormLabelComponent, NzFormControlComponent, HxCountrySelectComponent, HxEnumSelectComponent, HxLabelEditComponent, NzRadioGroupComponent, NzRadioComponent, HxOrgSelectComponent, NzDividerComponent, NzInputDirective, HxUserSelectComponent, NzUploadComponent, NzButtonComponent, NzWaveDirective, NzIconDirective, NgFor, NzTooltipDirective, NzPopconfirmDirective, NgIf, NzAlertComponent, NzTagComponent, NzModalComponent, NzModalContentDirective, HxStoreSelectComponent, HxBankSelectComponent, HxUiLabelPipe, TranslocoPipe]
})
export class OrganizationEditComponent implements OnInit, OnDestroy {
  model?: OrganizationModel;
  info?: OrganizationProperty;
  isEdit = false;
  isCreate = false;
  isSaving = false;
  storeDirectors: { user: UserBasicModel, store: StoreBasicModel }[] = [];
  isLoading = {
    model: false,
    stampFile: false,
    storeDirectors: false,
  };
  isVisible = {
    addStoreDirector: false,
    addBankAccount: false
  };
  fileUploadUrl!: string;
  stampFiles: NzUploadFile[] = [];
  storeId?: number;
  userId?: number;
  PaymentType = PaymentType;
  Currency = Currency;
  bankAccounts: BankAccountInfoModel[] = [];
  bankAccountRequest: Partial<BankAccountRequest> = {};
  isBankAccountEdit = false;
  form = new FormGroup({
    enabled: new FormControl<boolean | null>(null, Validators.required),
    title: new FormControl<UiLabel | null>(null, Validators.required),
    parentId: new FormControl<number | null>(null),
    currency: new FormControl<string | null>(null, Validators.required),
    epayOrgId: new FormControl<number | null>(null),
    paymentTypes: new FormControl<PaymentType[] | null>(null, Validators.required),
    invoicePaymentTypes: new FormControl<PaymentType[] | null>(null, Validators.required),
    countryId: new FormControl<number | null>(null, Validators.required),
    uin: new FormControl<string | null>(null, Validators.required),
    paymentDestinationCode: new FormControl<string | null>(null, Validators.required),
    postalIndex: new FormControl<string | null>(null, Validators.required),
    directorId: new FormControl<number | null>(null, Validators.required),
    accountantId: new FormControl<number | null>(null),
    stampFileId: new FormControl<number | null>(null),
    uinName: new FormControl<UiLabel | null>(null, Validators.required),
    taxType: new FormControl<string | null>(null, Validators.required),
    taxSeries: new FormControl<string | null>(null),
    taxNumber: new FormControl<string | null>(null),
    legalAddress: new FormControl<string | null>(null, Validators.required),
    ofdVerifierInfo: new FormControl<string | null>(null),
  });
  private storeDirectorIdMap = new Map<number, number>();

  private $destroyed = new Subject<void>();

  constructor(
    private aRoute: ActivatedRoute,
    private router: Router,
    private orgService: HxOrganizationService,
    private tr: TranslocoService,
    private notification: NzNotificationService,
    private auth: HxAuthService,
    private fileService: HxFileService,
    private userService: HxUserService,
    private storeService: HxStoreService,
  ) {
  }

  fileUploadHeadersFn = () => {
    const token = this.auth.keycloakToken();
    return {
      Authorization: `Bearer ${token}`,
      'ngsw-bypass': 'true'
    };
  };
  dataFn: (file: NzUploadFile) => {} | Observable<{}> = file => {
    const params: {
      folder?: string,
      temporary?: boolean,
      ref?: number,
      table?: string,
      file_name?: string,
    } = {
      folder: Folder.SYSTEM,
      file_name: `${SysFilename.stamp}.png`,
      temporary: true,
    };
    if (this.model) {
      params.ref = this.model.id;
      params.table = TableRef.hc_organizations;
    }
    return params;
  };

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.model = routeData['model'] as OrganizationModel;
    this.info = ((routeData['info'] ?? {}) as AppPropertyBasicModel).value as OrganizationProperty;
    if (this.model) {
      this.isEdit = true;
    } else {
      this.isCreate = true;
    }

    this.form.patchValue({
      enabled: this.model?.enabled ?? null,
      title: this.model?.title,
      parentId: this.model?.parentId,
      currency: this.model?.currency,
      epayOrgId: this.model?.epayOrgId,
      paymentTypes: this.model?.paymentTypes,
      invoicePaymentTypes: this.model?.invoicePaymentTypes,
      countryId: this.model?.countryId,
      // info prop fields
      uin: this.info?.uin,
      paymentDestinationCode: this.info?.paymentDestinationCode,
      postalIndex: this.info?.postalIndex,
      directorId: this.info?.directorId,
      accountantId: this.info?.accountantId,
      uinName: this.info?.uinName,
      taxType: this.info?.taxType,
      taxSeries: this.info?.taxSeries,
      taxNumber: this.info?.taxNumber,
      legalAddress: this.info?.legalAddress,
      ofdVerifierInfo: this.info?.ofdVerifierInfo,
    });
    this.fileUploadUrl = HxFileService.fileUploadUrl;

    if (this.model) {
      this.fileService.getFilesByRef({ref: this.model.id, table: TableRef.hc_organizations, folder: Folder.SYSTEM}).then(files => {
        const stampFiles = files.filter(f => f.fileName === `${SysFilename.stamp}.png`);
        if (stampFiles.length > 0) {
          this.stampFiles = stampFiles.map(f => ({uid: f.guid, name: f.fileName, url: `${HxFileService.fileDownloadUrl}/${f.guid}`}));
          this.form.controls['stampFileId'].setValue(stampFiles[0].id);
        }
      });
      this.loadBankAccounts(this.model.id);
    }
    if (this.info?.storeDirectorIdMap) {
      Object.entries(this.info.storeDirectorIdMap)
        .forEach(([key, value]) => this.storeDirectorIdMap.set(Number(key), value as number));
    }
    this.loadStoreDirectors();
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }

  async submitForm() {
    Object.values(this.form.controls).forEach(ctrl => {
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
    if (this.form.valid) {
      try {
        const formModel = this.form.value;
        if (!formModel.title
          || formModel.enabled === null || formModel.enabled === undefined
          || !formModel.currency
          || !formModel.countryId
        ) {
          throw new UiError('form.required.fields');
        }
        this.isSaving = true;
        const {id} = await this.orgService.saveOrganization({
          id: this.model?.id,
          enabled: formModel.enabled ?? null,
          title: formModel.title,
          parentId: formModel.parentId ?? undefined,
          currency: formModel.currency as Currency,
          epayOrgId: formModel.epayOrgId ?? undefined,
          paymentTypes: formModel.paymentTypes ?? [],
          countryId: formModel.countryId,
          invoicePaymentTypes: formModel.invoicePaymentTypes ?? [],
          stampFileId: formModel.stampFileId ?? undefined,
          info: {
            uin: formModel.uin ?? undefined,
            paymentDestinationCode: formModel.paymentDestinationCode ?? undefined,
            postalIndex: formModel.postalIndex ?? undefined,
            directorId: formModel.directorId ?? undefined,
            accountantId: formModel.accountantId ?? undefined,
            uinName: formModel.uinName ?? undefined,
            taxType: formModel.taxType ?? undefined,
            taxSeries: formModel.taxSeries ?? undefined,
            taxNumber: formModel.taxNumber ?? undefined,
            legalAddress: formModel.legalAddress ?? undefined,
            ofdVerifierInfo: formModel.ofdVerifierInfo ?? undefined,
            storeDirectorIdMap: Object.fromEntries(this.storeDirectorIdMap.entries()),
          },
        });
        this.form.markAsPristine();
        this.notification.create('success', this.tr.translate('nt.organization'), this.tr.translate('nt.dataSaved'));
        if (this.isCreate) {
          await this.router.navigate([`/organizations/${id}/edit`]);
        } else {
          this.isLoading.model = true;
          this.model = await this.orgService.getOrganizationById(id);
        }
      } finally {
        this.isLoading.model = false;
        this.isSaving = false;
      }
    } else {
      console.log('not valid form', this.form.errors);
    }
  }

  deleteStoreDirector(ix: number) {
    const storeId = this.storeDirectors[ix].store.id;
    this.storeDirectorIdMap.delete(storeId);
    this.storeDirectors.splice(ix, 1);
    this.form.markAsDirty();
  }

  onStampFileChanged(event: NzUploadChangeParam) {
    this.isLoading.stampFile = event.type === 'start' || event.type === 'progress';
    const stampFileControl = this.form.controls['stampFileId'];
    if (event.type === 'success') {
      stampFileControl.setValue(event.file.response.id);
      stampFileControl.markAsDirty();
      this.stampFiles = [{
        uid: event.file.response.guid,
        name: `${SysFilename.stamp}.png`,
        url: `${HxFileService.fileDownloadUrl}/${event.file.response.guid}`,
      }];
    } else if (event.type === 'removed') {
      stampFileControl.setValue(null);
      stampFileControl.markAsDirty();
      this.stampFiles = [];
    }
  }

  addDirector() {
    if (this.userId && this.storeId) {
      this.storeDirectorIdMap.set(this.storeId, this.userId);
      this.storeId = undefined;
      this.userId = undefined;
      this.loadStoreDirectors();
      this.isVisible.addStoreDirector = false;
      this.form.markAsDirty();
    } else {
      this.notification.error(this.tr.translate('nt.error'), this.tr.translate('nt.fillRequiredFields'));
    }
  }

  async setDefaultBankAccount(bankAccountId: number) {
    if (this.model) {
      const orgId = this.model.id;
      await this.orgService.setDefaultBankAccount(orgId, bankAccountId);
      this.loadBankAccounts(orgId);
      this.notification.success(this.tr.translate('nt.bankDetails'), this.tr.translate('nt.dataSaved'));
    }
  }

  async deleteBankAccount(bankAccountId: number) {
    if (this.model) {
      const orgId = this.model.id;
      await this.orgService.deleteBankAccount(orgId, bankAccountId);
      this.loadBankAccounts(orgId);
      this.notification.success(this.tr.translate('nt.bankDetails'), this.tr.translate('nt.dataRemoved'));
    }
  }

  async addBankAccount() {
    if (!this.model) {
      throw new Error('organization.undefined');
    }
    let orgId = this.model.id;
    this.bankAccountRequest.containerId = orgId;
    if (this.bankAccountRequest
      && this.bankAccountRequest.bankId
      && this.bankAccountRequest.iban
      && this.bankAccountRequest.beneficiaryCode
      && this.bankAccountRequest.currency
    ) {
      try {
        await this.orgService.saveBankAccount(orgId, {
          id: this.bankAccountRequest.id,
          bankId: this.bankAccountRequest.bankId,
          iban: this.bankAccountRequest.iban,
          beneficiaryCode: this.bankAccountRequest.beneficiaryCode,
          isDefault: this.bankAccountRequest.isDefault ?? false,
          currency: this.bankAccountRequest.currency,
          containerId: this.bankAccountRequest.containerId,
        });
        this.notification.success(this.tr.translate('nt.bankDetails'), this.tr.translate('nt.dataSaved'));
        this.bankAccountRequest = {};
        this.loadBankAccounts(orgId);
        this.isVisible.addBankAccount = false;
        this.form.markAsDirty();
      } catch (err: any) {
        this.notification.error(this.tr.translate('nav.bankDetails'), this.tr.translate(err?.error?.message));
      }
    } else {
      this.notification.error(this.tr.translate('nt.error'), this.tr.translate('nt.fillRequiredFields'));
    }
  }

  editBankAccounts(bankAccount: BankAccountInfoModel) {
    if (!this.model) {
      throw new Error('organization.undefined');
    }
    this.isBankAccountEdit = true;
    this.bankAccountRequest = {
      id: bankAccount.id,
      bankId: bankAccount.bank?.id,
      iban: bankAccount.iban,
      beneficiaryCode: bankAccount.beneficiaryCode,
      isDefault: bankAccount.default,
      currency: bankAccount.currency,
      containerId: this.model.id,
    };
    console.log('bankAccountRequest', this.bankAccountRequest);
    this.isVisible.addBankAccount = true;
  }

  private loadStoreDirectors() {
    if (this.storeDirectorIdMap.size > 0) {
      const storeIds = Array.from(this.storeDirectorIdMap.keys());
      const userIds = Array.from(this.storeDirectorIdMap.values());
      this.isLoading.storeDirectors = true;
      zip(this.storeService.getStoreByIds(storeIds), this.userService.getUserByIds(userIds))
        .pipe(finalize(() => this.isLoading.storeDirectors = false))
        .subscribe(([stores, users]) => {
          const storeDirectors: { user: UserBasicModel, store: StoreBasicModel }[] = [];
          this.storeDirectorIdMap.forEach((userId, storeId) => {
            const user = users.list.find(u => u.id === userId);
            const store = stores.find(s => s.id === storeId);
            if (user && store) {
              storeDirectors.push({user: user, store: store});
            }
          });
          this.storeDirectors = storeDirectors;
        });
    }
  }

  private async loadBankAccounts(orgId: number) {
    this.bankAccounts = await this.orgService.getBankAccounts(orgId);
  }
}
